// extracted by mini-css-extract-plugin
module.exports = {"pillClose":"pillClose__M_XnL","closeButton":"closeButton__2L7MQ","pillToggleOn":"pillToggleOn__3HQA6","pillToggleOff":"pillToggleOff__2ZAKI"};